<template>
    <div class="list_container">
        <div v-for="(item, index) in listData" :key="index" @click="setActiopFunGroup(item)">
            <div class="group_item" :style="{
                border: `1px solid ${customStyles.border_color}`,
                color: item.id === activeItem ? customStyles.active_font_color : customStyles.font_color,
                background: item.id === activeItem
                    ? '#dd8b3345'
                    : ''
            }" @click="goToGamePannel(item.id, item.groupType)">
                <img :src="item.customIcon" alt="">
                <div v-if="item.id === activeItem" class="group_item_arrow"></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { emitWithPreviewCheck, GroupList, setActiveItemFromClick, setFirstActiveItem } from '@/view/home/supportScript';
import { ref, defineProps, defineEmits, onMounted, computed, defineExpose, onBeforeMount } from 'vue'

const customStyles = ref({
    active_background_color: '',
    active_font_color: "",
    border_color: "",
    font_color: ""
})
const props = defineProps<{
    listData: GroupList[],
    itemData: {
        styles: {
            active_background_color: string,
            active_font_color: string,
            border_color: string,
            font_color: string
        }
    }
}>()
const localActiveItem = ref<string | number>('')

const activeItem = computed({
  get: () => localActiveItem.value || props.listData[0]?.id || '',
  set: (val) => {
    localActiveItem.value = val
  }
})
const emits = defineEmits(['goToGamePanel'])

const hexWithAlpha = (hex: string, alpha: number) => {
    return hex + Math.round(alpha * 255).toString(16).padStart(2, '0')
}
const color1 = computed(() => customStyles.value.active_background_color)
const color2 = computed(() => hexWithAlpha(color1.value, 0))
const color3 = computed(() => hexWithAlpha(color1.value, 0.5))
const color4 = computed(() => hexWithAlpha(color1.value, 0.04))

const setActiopFunGroup = (item: any) => {
    setActiveItemFromClick(item, localActiveItem)
}

const goToGamePannel = (id: number | string, groupType: number) => {
    let data = {
        id: id,
        groupType: groupType
    }
    emitWithPreviewCheck(emits, 'goToGamePanel', data)
}

const setActiveItem = () => {
    setFirstActiveItem(props.listData, localActiveItem)
}
defineExpose({
    setActiveItem,
})

onBeforeMount(()=>{
    setActiveItem();
});

onMounted(() => {
    customStyles.value.active_background_color = props.itemData.styles.active_background_color
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
    customStyles.value.font_color = props.itemData.styles.font_color
})
</script>
<style scoped>
.list_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    overflow-x: auto;
    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
    transition-property: transform;
    transition-duration: 0ms;
    margin: 15px 0 0;
}

.list_container::-webkit-scrollbar {
    display: none;
}

.group_item {
    flex-direction: column;
    position: relative;
    background: rgba(31, 11, 0, 0.02);
    margin: 0 3px 11px;
    border-radius: 9px;
    padding: 10px;
    /* height: 3.2rem; */
    display: flex;
    align-items: center;
    text-align: center;
    width: 110px;
}

.group_item img {
    height: 35px;
    /* width: 100px; */
    width: auto;
    max-width: 100px;
    /* padding-right: 5px;
    padding-top: 5px; */
}

.group_item_arrow {
    position: absolute;
    margin-top: 45px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #dd8b33;
}

.group_name {
    font-size: 15px;
    font-weight: 600;
    padding-top: 5px;
}
</style>